import * as React from "react";
import { IFormula } from "@graffer-inc/form-schema";
import {
  SecondaryButton,
  DangerSecondaryButton,
} from "@graffer-inc/console-design-kit";
import { InvoiceItemSetting } from "@graffer-inc/cloud-gov-core";
import { matchType } from "../../../../../../application/domain/base/base-type";

export const PaymentItemLine: React.FC<{
  item: InvoiceItemSetting;
  formula: IFormula | undefined;
  onEdit: () => void;
  onDelete: () => void;
  readonly?: boolean;
}> = ({ item, onEdit, onDelete, formula, readonly }) => {
  const partOfFormula =
    formula && formula.formula.length > 40
      ? formula?.formula.slice(0, 40).concat("...")
      : formula?.formula;
  return (
    <>
      <tr>
        <td>{item.description}</td>
        <td>
          <span className="tag is-rounded has-text-weight-bold">
            {matchType(item.taxRate, {
              "0": "非課税",
              "0.1": "10%",
              "0.08": "8%",
            })}
          </span>
        </td>
        <td>{item.formulaId}</td>
        <td>{partOfFormula}</td>
        <td>
          {!readonly && (
            <div className="buttons is-right">
              <SecondaryButton
                text="編集"
                icon="EditIcon"
                isSmall
                onClick={onEdit}
              />
              <DangerSecondaryButton
                text="削除"
                icon="TrashIcon"
                isSmall
                onClick={onDelete}
              />
            </div>
          )}
        </td>
      </tr>
    </>
  );
};
